export default __webpack_public_path__ + "static/media/ig-boost-profile-visits-img.54a54107.png";